<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      filtersData: {
        filters: [],
      },
    };
  },

  computed: {
    ...mapGetters({
      study: 'study',
      allFilters: 'filters',
    }),
  },

  mounted() {
    if (!localStorage.getItem(this.study.id)) {
      this.initFilters();
      localStorage.setItem(this.study.id, JSON.stringify(this.filtersData));
    } else {
      this.filtersData = JSON.parse(localStorage.getItem(this.study.id));
    }
  },

  methods: {
    initFilters() {
      this.filtersData.filters = this.defaultFilters(this.study);
      this.filtersData.filters.forEach(filter => {
        this.filtersData[filter.filterId] = this.$store.getters.ruleFilters[filter.filterId].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      });
    },

    defaultFilters(study) {
      return [
        {
          filterId: 'contractType',
          translation: this.$t('filters.byContractType'),
        },
        {
          filterId: 'seniority',
          translation: this.$t('filters.bySeniority'),
        },
        {
          filterId: 'service',
          translation: this.$t('filters.byService'),
        },
        {
          filterId: 'filter1',
          translation: `${this.$t('filters.by')}${study && study.filter1_name ? study.filter1_name : 'filter 1'}`,
        },
        {
          filterId: 'filter2',
          translation: `${this.$t('filters.by')}${study && study.filter2_name ? study.filter2_name : 'filter 2'}`,
        },
      ].sort((a, b) => a.translation.toLowerCase().localeCompare(b.translation.toLowerCase()));
    },

    resetFilters() {
      this.initFilters();
      localStorage.setItem(this.study.id, JSON.stringify(this.filtersData));
    },

    saveOrder() {
      localStorage.setItem(this.study.id, JSON.stringify(this.filtersData));
    },

    saveFilterCategories(data) {
      this.filtersData[data.filterId] = data.values;
      this.saveOrder();
    },
  },
};
</script>
